import { useBookingFormStore } from '../providers/BookingFormStoreProvider'

export const useIsChildrenOrPets = () => {
  const childrenCount = useBookingFormStore((state) => state.childrenCount)
  const petsCount = useBookingFormStore((state) => state.petsCount)
  const isChildrenOrPets = childrenCount > 0 || petsCount > 0

  return isChildrenOrPets
}
